(function () {
  'use strict';

  var configElement = document.getElementById('rocka-cart-market-config');
  if (!configElement) return;
  var config = JSON.parse(configElement.textContent);
  var root = (window.Shopify.routes.root || '/').replace(/\/$/, '') + '/';
  var pending;
  var timer;
  var products = new Map();
  var removedNames = new Set();
  var permittedSubmits = new WeakSet();
  var permittedLinks = new WeakSet();

  async function cartRequest() {
    var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check cart');
    return response.json();
  }

  async function productFor(handle) {
    if (!products.has(handle)) {
      products.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin', cache: 'no-store'
      }).then(function (response) {
        if (response.status === 404) return null;
        if (!response.ok) throw new Error('Unable to check product market');
        return response.json();
      }).catch(function (error) {
        products.delete(handle);
        throw error;
      }));
    }
    return products.get(handle);
  }

  function renderNotice() {
    if (!removedNames.size) return;
    document.querySelectorAll('#sidebar-cart .Drawer__Main, .template-cart .Cart').forEach(function (container) {
      var notice = container.querySelector('[data-cart-market-notice]');
      if (!notice) {
        notice = document.createElement('p');
        notice.dataset.cartMarketNotice = '';
        notice.className = 'Drawer__Container';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        container.prepend(notice);
      }
      var message = config.removed.replace('__products__', Array.from(removedNames).join(', '));
      if (notice.textContent !== message) notice.textContent = message;
    });
  }

  async function check() {
    var cart = await cartRequest();
    var excluded = new Set();
    await Promise.all(cart.items.map(async function (item) {
      if (item.original_price === 0 && /-sca_clone_freegift$/.test(item.handle)) return;
      var product = await productFor(item.handle);
      if (product === null || Array.isArray(product.variants) && product.variants.length < 250 && !product.variants.some(function (variant) {
        return String(variant.id) === String(item.variant_id);
      })) excluded.add(String(item.variant_id));
    }));
    if (!excluded.size) return false;

    cart = await cartRequest();
    var updates = {};
    var names = [];
    cart.items.forEach(function (item) {
      if (!excluded.has(String(item.variant_id))) return;
      updates[item.key] = 0;
      names.push(item.product_title);
    });
    if (!names.length) return false;
    var response = await fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) throw new Error('Unable to remove excluded cart items');
    var updated = await response.json();
    names.forEach(function (name) { removedNames.add(name); });
    document.querySelectorAll('.Header__CartCount').forEach(function (element) {
      element.textContent = String(updated.item_count);
    });
    document.querySelectorAll('.Header__CartDot').forEach(function (element) {
      element.classList.toggle('is-visible', updated.item_count > 0);
    });
    if (document.body.classList.contains('template-cart')) {
      sessionStorage.setItem('rocka-cart-market-notice', JSON.stringify({ country: config.country, names: Array.from(removedNames) }));
      window.location.reload();
    } else if (window.RockaSideCart) {
      await window.RockaSideCart.refresh(false);
    }
    renderNotice();
    return true;
  }

  function ensure() {
    if (!pending) pending = check().finally(function () { pending = null; });
    return pending;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { ensure().catch(function () {}); }, 150);
  }

  function checkoutLink(element) {
    var link = element.closest('a[href]');
    if (!link) return null;
    var url = new URL(link.href, window.location.origin);
    return url.origin === location.origin && /\/(?:cart\/)?checkout\/?$/.test(url.pathname) ? link : null;
  }

  document.addEventListener('click', function (event) {
    var link = checkoutLink(event.target);
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (permittedLinks.has(link)) {
      permittedLinks.delete(link);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    ensure().then(function (changed) {
      if (changed) {
        if (window.RockaSideCart) window.RockaSideCart.open();
      } else {
        permittedLinks.add(link);
        link.click();
      }
    }).catch(function () { window.location.assign(link.href); });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var button = event.submitter;
    if (!button || button.name !== 'checkout') return;
    if (permittedSubmits.has(form)) {
      permittedSubmits.delete(form);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    ensure().then(function (changed) {
      if (changed) {
        if (window.RockaSideCart) window.RockaSideCart.open();
        return;
      }
      permittedSubmits.add(form);
      form.requestSubmit(button);
    }).catch(function () { window.location.assign(root + 'checkout'); });
  }, true);

  ['product:added', 'cart:refresh', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-drawer-id="sidebar-cart"]')) schedule();
  });
  var drawer = document.getElementById('sidebar-cart');
  if (drawer) new MutationObserver(function (records) {
    renderNotice();
    if (records.some(function (record) {
      return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
        return node.nodeType === 1 && (node.matches('.Cart, .CartItem, .CartItemWrapper') || node.querySelector('.CartItem'));
      });
    })) schedule();
  }).observe(drawer, { childList: true, subtree: true });
  try {
    var saved = JSON.parse(sessionStorage.getItem('rocka-cart-market-notice'));
    sessionStorage.removeItem('rocka-cart-market-notice');
    if (saved && saved.country === config.country) saved.names.forEach(function (name) { removedNames.add(name); });
  } catch (error) {}
  window.addEventListener('pageshow', function () { products.clear(); schedule(); });
  window.RockaCartMarket = { ensure: ensure };
  renderNotice();
  schedule();
})();
